import { render } from "./EdgeData.vue?vue&type=template&id=6cc77d50&scoped=true"
import script from "./EdgeData.vue?vue&type=script&lang=js"
export * from "./EdgeData.vue?vue&type=script&lang=js"

import "./EdgeData.vue?vue&type=style&index=0&id=6cc77d50&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc77d50"]])

export default __exports__